export default __webpack_public_path__ + "static/media/logo_amp.cc483b77.svg";